import { FormControl } from '@angular/forms';

export class PhoneValidator {
  static isValid(control: FormControl) {
    // Validación para números de teléfono de 10 dígitos (formato mexicano)
    const phoneRegex = /^\d{10}$/;
    const isValid = phoneRegex.test(control.value);
    
    if (isValid || control.value == '') {
      return null;
    }
    return { invalidPhone: true };
  }

  // Validador alternativo que permite espacios, guiones y paréntesis
  static isValidWithFormatting(control: FormControl) {
    // Permite formatos como: (55) 1234-5678, 55-1234-5678, 55 1234 5678
    const phoneRegexWithFormat = /^[\d\s\-\(\)]{10,}$/;
    const cleanPhone = control.value?.replace(/[\s\-\(\)]/g, '');
    const isValid = /^\d{10}$/.test(cleanPhone);
    
    if (isValid || control.value == '') {
      return null;
    }
    return { invalidPhoneFormat: true };
  }

  // Validador que acepta números de 8 a 15 dígitos (estándar internacional)
  static isValidInternational(control: FormControl) {
    const phoneRegex = /^\d{8,15}$/;
    const isValid = phoneRegex.test(control.value);
    
    if (isValid || control.value == '') {
      return null;
    }
    return { invalidPhoneInternational: true };
  }
}
